import type { IconData } from '@stacksjs/iconify-core'

export const thunder: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8.997 6.968H6.708V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5.923a1 1 0 0 0 .966 1l1.937.061v7.404a.549.549 0 0 0 1.053.216l3.96-9.242a1 1 0 0 0-.92-1.394zM8.708 3v1.968h.289a3 3 0 0 1 2.757 4.181l-3.96 9.243a2.549 2.549 0 0 1-4.891-1.004v-5.466A3 3 0 0 1 0 8.923V3a3 3 0 0 1 3-3h2.708a3 3 0 0 1 3 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default thunder
